<div *transloco="let t; read: translation"
     [@showHide]="animatedModalState"
     [dndAllowExternal]="true"
     [dndDragoverClass]="!disabled && allowDrop && dragFileValid ? 'dragover' : 'no-dragover'"
     [dndDropzone]="[]"
     (dndDrop)="!disabled && allowDrop ? setFile($any($event.event.dataTransfer).files) : $event.event.preventDefault()"
     (dragenter)="checkDragFile($event)"
     class="file-picker-wrapper appearance-{{appearance}}"
     dndEffectAllowed="copy">

  <div *ngIf="!disabled && allowDrop"
       [ngClass]="{'justify-content-center': appearance === 'area' || appearance === 'button', 'flex-column': flexColumn}"
       class="drag-overlay d-flex text-muted">
    <ng-content select=".icon-overlay"></ng-content>
    <p aria-hidden="true" class="ml-2 mb-0">{{ t('drop_info')}}</p>
  </div>

  <ng-content></ng-content>

  <input #fileInput
         [accept]="mimeTypes?.toString()"
         [multiple]="multiple"
         (change)="setFile($any($event.target).files)"
         class="d-none"
         style="pointer-events: none"
         type="file">

  <div *ngIf="(appearance === 'area' || appearance === 'block' || appearance === 'button')"
       [ngClass]="{ 'disabled': disabled, 'd-none': file, 'align-items-center flex-column' : appearance === 'button', 'size-lg' : size === 'lg'}"
       class="file-picker-inner">
    <div *ngIf="appearance === 'area' || appearance === 'block'"
         [ngClass]="{'flex-column': flexColumn}"
         class="file-picker-content d-flex align-items-center">
      <ng-content select=".icon"></ng-content>
      <ng-content select=".extra-info"></ng-content>
      <p class="header d-none d-lg-flex mb-0 ml-2">{{t(multiple ? 'drop_multiple' : 'drop')}}</p>
      <p class="header d-flex d-lg-none mb-0 ml-2">{{t('tap')}}</p>
    </div>

    <ng-container *ngIf="appearance === 'button'">
      <ng-container *ngIf="!hideDropInfo">
        <p class="header d-none d-lg-flex mb-0 ml-2">{{t('drop_only')}}</p>
        <p class="small mb-2 mt-2">{{t('or')}}</p>
      </ng-container>

      <button (click)="fileInput.click()"
              class="btn btn-pl-primary"
              type="button">
        {{t('choose')}}
      </button>
      <p class="extensions text-muted small text-center mt-2 mb-0">
        {{t('allowed')}}

        <ng-container *ngIf="mimeTypes.length > 0">
          <span *ngFor="let type of mimeTypes"
                class="text-uppercase font-weight-bold">
            {{'base.mime_types.' + type | transloco}}
          </span>
        </ng-container>

        <span *ngIf="mimeTypes.length === 0"
              class="font-weight-bold">
          {{t('all_mime_types')}}
        </span>
      </p>
    </ng-container>
  </div>

  <button *ngIf="(appearance === 'button' && file) || appearance === 'compact'"
          [ngClass]="{'btn-pl-lark text-dark': file, 'btn-pl-primary': !file && appearance !== 'compact',
          'btn-light': !file && appearance === 'compact'}"
          (click)="fileInput.click(); $event.preventDefault()"
          class="btn w-100"
          type="button">
    <span *ngIf="file">{{t('replace')}}</span>
    <span *ngIf="!file">{{t('choose')}}</span>
  </button>

  <p *ngIf="(appearance === 'button' && file)"
     class="text-muted small text-center mt-2 mb-0">
    {{t('allowed')}}

    <ng-container *ngIf="mimeTypes.length > 0">
      <span *ngFor="let type of mimeTypes"
            class="text-uppercase font-weight-bold">
        {{'base.mime_types.' + type | transloco}}
      </span>
    </ng-container>

    <span *ngIf="mimeTypes.length === 0"
          class="font-weight-bold">
      {{t('all_mime_types')}}
    </span>
  </p>
</div>
